import live from '../../../../config/static_data/seasons/live.json'
import classicAnniversary from '../../../../config/static_data/seasons/classic_anniversary.json'
import classicEra from '../../../../config/static_data/seasons/classic_era.json'
import classicProgression from '../../../../config/static_data/seasons/classic_progression.json'

export type SeasonEntry = {
  id: number
  name: string
  start_date: string
  end_date: string | null
  game_version: string
  expansion: string
  first_period_id?: number
  tier_id: number
  metadata: {
    keystone_dungeons?: {
      id: number
      name: string
      key?: string
      background?: string
      mythic_id: number
      legacy: boolean
    }[]
  }
}

const byGameVersion: Record<string, SeasonEntry[]> = {
  live,
  classic_anniversary: classicAnniversary,
  classic_era: classicEra,
  classic_progression: classicProgression,
}

export function getSeasonData(
  gameVersion: wowaudit.PageInfo['gameVersion'],
): SeasonEntry[] {
  return byGameVersion[gameVersion] ?? []
}
